import { useEffect } from 'react'

/**
 * Run `effect` once on mount. The only sanctioned escape hatch for one-time
 * external-system sync (DOM integration, browser API, third-party widget).
 * Components must reach for this — never `useEffect` directly.
 */
export function useMountEffect(effect: () => void | (() => void)) {
  // eslint-disable-next-line react-hooks/exhaustive-deps, no-restricted-syntax
  useEffect(effect, [])
}
